<div class="bg-gray-60 p-3">
  <nav class="br-pagination dark-mode" aria-label="paginação">
    <ul>
      <!-- Botão anterior -->
      <li>
        <button
          class="br-button circle"
          type="button"
          (click)="anterior()"
          aria-label="Voltar página"
        >
          <i class="fas fa-angle-left" aria-hidden="true"></i>
        </button>
      </li>

      <div *ngFor="let pagina of paginasPrincipais">
        <a
          *ngIf="pagina !== 'ellipsis-left' && pagina !== 'ellipsis-right'"
          href="javascript:void(0)"
          class="page"
          [class.active]="pagina === paginaAtual"
          [attr.aria-label]="'Página ' + pagina"
          (click)="alterarPagina(pagina)"
        >
          {{ pagina }}
        </a>

        <!-- Reticências no dropdown esquerdo -->
        <div *ngIf="pagina === 'ellipsis-left'" class="pagination-ellipsis">
          <button
            class="br-button circle"
            type="button"
            (click)="toggleDropdownEsquerdo()"
            aria-label="Abrir páginas anteriores"
          >
            <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
          </button>
          <div class="br-list" role="menu" *ngIf="showDropdownEsquerdo">
            <ng-container
              *ngFor="let pagina of paginasEsquerda(); let i = index"
            >
              <a
                class="br-item"
                href="javascript:void(0)"
                (click)="alterarPagina(pagina); fecharDropdowns()"
                [attr.aria-label]="'Página ' + pagina"
                role="menuitem"
              >
                {{ pagina }}
              </a>
              <hr class="br-divider" *ngIf="i < paginasEsquerda().length - 1" />
            </ng-container>
          </div>
        </div>

        <!-- Reticências no dropdown direito -->
        <div *ngIf="pagina === 'ellipsis-right'" class="pagination-ellipsis">
          <button
            class="br-button circle"
            type="button"
            (click)="toggleDropdownDireito()"
            aria-label="Abrir páginas seguintes"
          >
            <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
          </button>
          <div class="br-list" role="menu" *ngIf="showDropdownDireito">
            <ng-container
              *ngFor="let pagina of paginasDireita(); let i = index"
            >
              <a
                class="br-item"
                href="javascript:void(0)"
                (click)="alterarPagina(pagina); fecharDropdowns()"
                [attr.aria-label]="'Página ' + pagina"
                role="menuitem"
              >
                {{ pagina }}
              </a>
              <!-- Linha separadora -->
              <hr class="br-divider" *ngIf="i < paginasDireita().length - 1" />
            </ng-container>
          </div>
        </div>
      </div>

      <li>
        <button
          class="br-button circle"
          type="button"
          (click)="proximo()"
          aria-label="Próxima página"
        >
          <i class="fas fa-angle-right" aria-hidden="true"></i>
        </button>
      </li>
    </ul>
  </nav>
</div>
